import { Link, useOutletContext } from '@remix-run/react'
import { EyebrowLabel } from '#app/components/eyebrow-label.tsx'
import { MarketingSection } from './marketing-section.tsx'

const ctaButtonClass =
	'mt-8 inline-block rounded-md bg-ember px-5 py-3 text-sm font-medium text-ink hover:opacity-90'

/**
 * Universal final-CTA section. Renders nothing for authenticated users.
 * Reads isAuthenticated from the marketing layout's outlet context.
 */
export function EndCap() {
	const ctx = useOutletContext<{
		isAuthenticated: boolean
		signupEnabled: boolean
	} | null>()
	if (ctx?.isAuthenticated) return null
	if (!ctx?.signupEnabled) {
		return (
			<MarketingSection tone="ink-soft">
				<EyebrowLabel>Start building momentum</EyebrowLabel>
				<h2 className="mt-5 font-display text-display-2">
					Momentum is invite-only right now.
				</h2>
				<p className="mt-4 max-w-xl text-base leading-relaxed text-ink-fg-soft">
					Athletes join through an invitation from their coach. Coaches: we'd
					love to hear from you.
				</p>
				<Link to="/support" className={ctaButtonClass}>
					Request access
				</Link>
			</MarketingSection>
		)
	}
	return (
		<MarketingSection tone="ink-soft">
			<EyebrowLabel>Start building momentum</EyebrowLabel>
			<h2 className="mt-5 font-display text-display-2">
				Take your first step.
			</h2>
			<p className="mt-4 max-w-xl text-base leading-relaxed text-ink-fg-soft">
				Sign up and choose your role — coach or athlete — during onboarding.
			</p>
			<div className="flex flex-col gap-4 sm:flex-row">
				<Link to="/signup" className={ctaButtonClass}>
					Sign up as a coach
				</Link>
				<Link to="/signup" className={ctaButtonClass}>
					Sign up as an athlete
				</Link>
			</div>
		</MarketingSection>
	)
}
